import type { Theme } from "@mui/material/styles";

/** The edge an edge shadow is cast from. */
export type EdgeShadowSide = "top" | "bottom" | "right";

const OFFSETS: Record<EdgeShadowSide, string> = {
  top: "0 -2px",
  bottom: "0 2px",
  right: "2px 0",
};

/**
 * A soft box-shadow cast from one edge of a fixed part of the page over what scrolls beside it,
 * in the divider colour. The element needs position relative, a zIndex and an opaque background.
 */
export const toEdgeShadow = (theme: Theme, side: EdgeShadowSide): string => {
  const color = theme.vars?.palette.divider ?? theme.palette.divider;
  return `${OFFSETS[side]} 6px ${color}`;
};
